import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import Appconfig from "../config/config";

// import Helper from "../helper";
import {
  setUserInfo,
  emptyUserInfo,
} from "../redux/slice/userInfo/userInfoSlice";
import { emptyLoingUserData } from "../redux/slice/userData/userDataSlice";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const sessionCheckInFlightRef = useRef(false);

  // const [isAuthenticated, setIsAuthenticated] = useState(() =>
  //   Boolean(Helper())
  // );

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    try {
      const storedUser = localStorage.getItem("userdata");
      return Boolean(storedUser);
    } catch (error) {
      console.error("Unable to check authentication:", error);
      return false;
    }
  });

  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("userdata");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Stored user data is invalid:", error);
      localStorage.removeItem("userdata");
      return null;
    }
  });

  // const login = useCallback(
  //   (userData) => {
  //     if (!userData?.login_token) {
  //       console.error("Login token is missing");
  //       return false;
  //     }

  //     setUser(userData);
  //     setIsAuthenticated(true);

  //     // Redux mein user data save karega.
  //     dispatch(setUserInfo(userData));

  //     localStorage.setItem("userdata", JSON.stringify(userData));
  //     localStorage.setItem("login_token", userData.login_token);
  //     localStorage.setItem("loginTime", Date.now().toString());

  //     return true;
  //   },
  //   [dispatch]
  // );

  const login = useCallback(
    (userData) => {
      if (!userData?.login_token) {
        console.error("Login token is missing");

        setUser(null);
        setIsAuthenticated(false);

        return false;
      }

      setUser(userData);
      setIsAuthenticated(true);

      // dispatch(setUserInfo(userData));
      dispatch(
        setUserInfo({
          key: "userdata",
          value: userData,
        })
      );

      localStorage.setItem(
        "userdata",
        JSON.stringify(userData)
      );

      localStorage.setItem(
        "loginTime",
        Date.now().toString()
      );

      // API token bhejti hai toh save hoga.
      // Token nahi milne par login fail nahi hoga.
      if (userData.login_token) {
        localStorage.setItem(
          "login_token",
          userData.login_token
        );
      } else {
        localStorage.removeItem("login_token");
      }

      return true;
    },
    [dispatch]
  );

  const logout = useCallback(() => {
    setUser(null);
    setIsAuthenticated(false);

    dispatch(emptyUserInfo());
    dispatch(emptyLoingUserData());

    localStorage.removeItem("userdata");
    localStorage.removeItem("login_token");
    localStorage.removeItem("loginTime");
  }, [dispatch]);

  const validateCurrentSession = useCallback(async () => {
    if (sessionCheckInFlightRef.current) {
      return;
    }

    const currentUserId = user?._id;

    const currentToken =
      user?.login_token ||
      localStorage.getItem("login_token");

    if (!currentUserId || !currentToken) {
      logout();
      window.location.replace("/login");
      return;
    }

    sessionCheckInFlightRef.current = true;

    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}userToken/getToken`,
        {
          user_id: String(currentUserId),
          login_token: String(currentToken),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const sessionIsValid =
        response?.data?.result === true ||
        response?.data?.result === 1 ||
        response?.data?.result === "1";

      if (!sessionIsValid) {
        logout();

        window.location.replace("/login");
      }
    } catch (error) {
      /*
       * Temporary internet/server error par logout nahi
       * karenge. Sirf confirmed token mismatch par logout.
       */
      console.error(
        "Unable to verify login session:",
        error?.response?.data ||
        error?.message ||
        error
      );
    } finally {
      sessionCheckInFlightRef.current = false;
    }
  }, [user?._id, user?.login_token, logout]);

  useEffect(() => {
    if (!isAuthenticated || !user?._id) {
      return undefined;
    }

    // Page load par turant token check hoga.
    validateCurrentSession();

    // Har 10 seconds check karega.
    const sessionInterval = window.setInterval(
      validateCurrentSession,
      10000
    );

    // User tab par wapas aaye toh turant check.
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        validateCurrentSession();
      }
    };

    // Window focus hone par check.
    const handleWindowFocus = () => {
      validateCurrentSession();
    };

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    window.addEventListener(
      "focus",
      handleWindowFocus
    );

    return () => {
      window.clearInterval(sessionInterval);

      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );

      window.removeEventListener(
        "focus",
        handleWindowFocus
      );
    };
  }, [
    isAuthenticated,
    user?._id,
    validateCurrentSession,
  ]);

  const signup = useCallback(
    (userData) => {
      return login(userData);
    },
    [login]
  );

  // Page refresh ke baad stored login restore karega.
  // useEffect(() => {
  //   const token = localStorage.getItem("login_token");

  //   let storedUser = null;

  //   try {
  //     const value = localStorage.getItem("userdata");
  //     storedUser = value ? JSON.parse(value) : null;
  //   } catch (error) {
  //     console.error("Unable to restore user:", error);
  //   }

  //   const validSession = Boolean(token && Helper());

  //   if (!validSession) {
  //     logout();
  //     return;
  //   }

  //   setIsAuthenticated(true);

  //   if (storedUser) {
  //     setUser(storedUser);
  //     dispatch(setUserInfo(storedUser));
  //   }
  // }, [dispatch, logout]);

  useEffect(() => {
    try {
      const storedValue =
        localStorage.getItem("userdata");

      if (!storedValue) {
        setUser(null);
        setIsAuthenticated(false);
        return;
      }

      const storedUser = JSON.parse(storedValue);

      if (!storedUser) {
        logout();
        return;
      }

      setUser(storedUser);
      setIsAuthenticated(true);
      // dispatch(setUserInfo(storedUser));

      dispatch(
        setUserInfo({
          key: "userdata",
          value: storedUser,
        })
      );

    } catch (error) {
      console.error(
        "Unable to restore user:",
        error
      );

      logout();
    }
  }, [dispatch, logout]);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        login,
        signup,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
};